import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useRef } from "react";
import clsx from "clsx";
import { useNavigate } from "react-router";
import { ICustomerProfileState } from "@/app_redux/reducers/slices/auth/customer_profile_slice";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";

export interface ICheckoutProps {
  phone_number: string;
}

export default function OrderPlacedModal({ open, cod }) {
  const cancelButtonRef = useRef(null);
  const navigate = useNavigate();
  const { getRouteKey } = useRouter();
  const { routeState } = useRouteInfo(getRouteKey("CUSTOMER_PROFILE", "id"));
  const { customerId, petId } = routeState.state as ICustomerProfileState;

  const handleGoHome = () => {
    navigate(`/app/customer/profile/customer-details/appointments/${customerId}/${petId}`);
  };

  return (
    <div>
      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="relative z-40" initialFocus={cancelButtonRef} onClose={() => {}}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>
          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel
                  className={`relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-4 sm:w-[500px] sm:p-6 flex flex-col `}
                >
                  <div className="pb-2">
                    <div className="flex justify-center">
                      <img
                        src="https://vetic-img.s3.ap-south-1.amazonaws.com/quick_commerce//misc/confirme_Icon.svg"
                        alt="check_icon"
                      />
                    </div>
                    <div className="text-base font-semibold text-center mt-5">Order Placed</div>
                    {!cod && <div className="text-sm text-center mt-2 text-[#777985]">Payment Pending</div>}
                    <div>
                      <button
                        type="submit"
                        onClick={handleGoHome}
                        className={clsx(
                          "rounded-md w-full px-10 py-[9px] mt-5 font-normal text-sm shadow-sm bg-black text-white cursor-pointer",
                        )}
                      >
                        Go Home
                      </button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
}
